/**
 * Icons.jsx
 * Created by michaelbray on 7/9/17.
 */

import BaseIcon from './BaseIcon';

export class IconWarning extends BaseIcon { }
IconWarning.defaultProps = {
    iconName: 'rec-icon-warning',
    iconClass: 'rec-icon-warning'
};

export class IconInfo extends BaseIcon { }
IconInfo.defaultProps = {
    iconName: 'rec-icon-info',
    iconClass: 'rec-icon-info'
};

export class IconError extends BaseIcon { }
IconError.defaultProps = {
    iconName: 'rec-icon-error',
    iconClass: 'rec-icon-error'
};

export class IconCheckCircle extends BaseIcon { }
IconCheckCircle.defaultProps = {
    iconName: 'rec-icon-check-circle',
    iconClass: 'rec-icon-check-circle'
};

export class IconClose extends BaseIcon { }
IconClose.defaultProps = {
    iconName: 'rec-icon-close',
    iconClass: 'rec-icon-close'
};

export class IconPerson extends BaseIcon { }
IconPerson.defaultProps = {
    iconName: 'rec-icon-person',
    iconClass: 'rec-icon-person'
};

export class IconCart extends BaseIcon { }
IconCart.defaultProps = {
    iconName: 'rec-icon-cart',
    iconClass: 'rec-icon-cart'
};

export class IconCog extends BaseIcon { }
IconCog.defaultProps = {
    iconName: 'rec-icon-cog',
    iconClass: 'rec-icon-cog'
};

export class IconSearch extends BaseIcon { }
IconSearch.defaultProps = {
    iconName: 'rec-icon-search',
    iconClass: 'rec-icon-search'
};

export class IconCloseCircle extends BaseIcon { }
IconCloseCircle.defaultProps = {
    iconName: 'rec-icon-close-circle',
    iconClass: 'rec-icon-close-circle'
};

export class IconCalendar extends BaseIcon { }
IconCalendar.defaultProps = {
    iconName: 'rec-icon-calendar',
    iconClass: 'rec-icon-calendar'
};

export class IconArrowUp extends BaseIcon { }
IconArrowUp.defaultProps = {
    iconName: 'rec-icon-arrow-up',
    iconClass: 'rec-icon-arrow-up'
};

export class IconArrowDown extends BaseIcon { }
IconArrowDown.defaultProps = {
    iconName: 'rec-icon-arrow-down',
    iconClass: 'rec-icon-arrow-down'
};

export class IconChevronLeft extends BaseIcon { }
IconChevronLeft.defaultProps = {
    iconName: 'rec-icon-chevron-left',
    iconClass: 'rec-icon-chevron-left'
};

export class IconChevronRight extends BaseIcon { }
IconChevronRight.defaultProps = {
    iconName: 'rec-icon-chevron-right',
    iconClass: 'rec-icon-chevron-right'
};

export class IconChevronUp extends BaseIcon { }
IconChevronUp.defaultProps = {
    iconName: 'rec-icon-chevron-up',
    iconClass: 'rec-icon-chevron-up'
};

export class IconChevronDown extends BaseIcon { }
IconChevronDown.defaultProps = {
    iconName: 'rec-icon-chevron-down',
    iconClass: 'rec-icon-chevron-down'
};

export class IconAddCircle extends BaseIcon { }
IconAddCircle.defaultProps = {
    iconName: 'rec-icon-add-circle',
    iconClass: 'rec-icon-add-circle'
};

export class IconPeople extends BaseIcon { }
IconPeople.defaultProps = {
    iconName: 'rec-icon-people',
    iconClass: 'rec-icon-people'
};

export class IconAccessibility extends BaseIcon { }
IconAccessibility.defaultProps = {
    iconName: 'rec-icon-accessibility',
    iconClass: 'rec-icon-accessibility'
};

export class IconAccountBox extends BaseIcon { }
IconAccountBox.defaultProps = {
    iconName: 'rec-icon-account-box',
    iconClass: 'rec-icon-account-box'
};

export class IconSupervisorAccount extends BaseIcon { }
IconSupervisorAccount.defaultProps = {
    iconName: 'rec-icon-supervisor-account',
    iconClass: 'rec-icon-supervisor-account'
};

export class IconAccountCircle extends BaseIcon { }
IconAccountCircle.defaultProps = {
    iconName: 'rec-icon-account-circle',
    iconClass: 'rec-icon-account-circle'
};

export class IconCalendarAvailable extends BaseIcon { }
IconCalendarAvailable.defaultProps = {
    iconName: 'rec-icon-calendar-available',
    iconClass: 'rec-icon-calendar-available'
};

export class IconCalendarBusy extends BaseIcon { }
IconCalendarBusy.defaultProps = {
    iconName: 'rec-icon-calendar-busy',
    iconClass: 'rec-icon-calendar-busy'
};

export class IconCalendarNote extends BaseIcon { }
IconCalendarNote.defaultProps = {
    iconName: 'rec-icon-calendar-note',
    iconClass: 'rec-icon-calendar-note'
};

export class IconClock extends BaseIcon { }
IconClock.defaultProps = {
    iconName: 'rec-icon-clock',
    iconClass: 'rec-icon-clock'
};

export class IconGroupAdd extends BaseIcon { }
IconGroupAdd.defaultProps = {
    iconName: 'rec-icon-group-add',
    iconClass: 'rec-icon-group-add'
};

export class IconHome extends BaseIcon { }
IconHome.defaultProps = {
    iconName: 'rec-icon-home',
    iconClass: 'rec-icon-home'
};

export class IconMood extends BaseIcon { }
IconMood.defaultProps = {
    iconName: 'rec-icon-mood',
    iconClass: 'rec-icon-mood'
};

export class IconPeopleOutline extends BaseIcon { }
IconPeopleOutline.defaultProps = {
    iconName: 'rec-icon-people-outline',
    iconClass: 'rec-icon-people-outline'
};

export class IconPersonAdd extends BaseIcon { }
IconPersonAdd.defaultProps = {
    iconName: 'rec-icon-person-add',
    iconClass: 'rec-icon-person-add'
};

export class IconPersonOutline extends BaseIcon { }
IconPersonOutline.defaultProps = {
    iconName: 'rec-icon-person-outline',
    iconClass: 'rec-icon-person-outline'
};

export class IconPortrait extends BaseIcon { }
IconPortrait.defaultProps = {
    iconName: 'rec-icon-portrait',
    iconClass: 'rec-icon-portrait'
};

export class IconAddCircleOutline extends BaseIcon { }
IconAddCircleOutline.defaultProps = {
    iconName: 'rec-icon-add-circle-outline',
    iconClass: 'rec-icon-add-circle-outline'
};

export class IconAdd extends BaseIcon { }
IconAdd.defaultProps = {
    iconName: 'rec-icon-add',
    iconClass: 'rec-icon-add'
};

export class IconArrowCorner extends BaseIcon { }
IconArrowCorner.defaultProps = {
    iconName: 'rec-icon-arrow-corner',
    iconClass: 'rec-icon-arrow-corner'
};

export class IconArrowBack extends BaseIcon { }
IconArrowBack.defaultProps = {
    iconName: 'rec-icon-arrow-back',
    iconClass: 'rec-icon-arrow-back'
};

export class IconArrowForward extends BaseIcon { }
IconArrowForward.defaultProps = {
    iconName: 'rec-icon-arrow-forward',
    iconClass: 'rec-icon-arrow-forward'
};

export class IconArrowTop extends BaseIcon { }
IconArrowTop.defaultProps = {
    iconName: 'rec-icon-arrow-top',
    iconClass: 'rec-icon-arrow-top'
};

export class IconArrowBottom extends BaseIcon { }
IconArrowBottom.defaultProps = {
    iconName: 'rec-icon-arrow-bottom',
    iconClass: 'rec-icon-arrow-bottom'
};

export class IconCheck extends BaseIcon { }
IconCheck.defaultProps = {
    iconName: 'rec-icon-check',
    iconClass: 'rec-icon-check'
};

export class IconMoreHoriz extends BaseIcon { }
IconMoreHoriz.defaultProps = {
    iconName: 'rec-icon-more-horiz',
    iconClass: 'rec-icon-more-horiz'
};

export class IconMoreVert extends BaseIcon { }
IconMoreVert.defaultProps = {
    iconName: 'rec-icon-more-vert',
    iconClass: 'rec-icon-more-vert'
};

export class IconRefresh extends BaseIcon { }
IconRefresh.defaultProps = {
    iconName: 'rec-icon-refresh',
    iconClass: 'rec-icon-refresh'
};

export class IconTrendingFlat extends BaseIcon { }
IconTrendingFlat.defaultProps = {
    iconName: 'rec-icon-trending-flat',
    iconClass: 'rec-icon-trending-flat'
};

export class IconBackspace extends BaseIcon { }
IconBackspace.defaultProps = {
    iconName: 'rec-icon-backspace',
    iconClass: 'rec-icon-backspace'
};

export class IconFileDownload extends BaseIcon { }
IconFileDownload.defaultProps = {
    iconName: 'rec-icon-file-download',
    iconClass: 'rec-icon-file-download'
};

export class IconFileUpload extends BaseIcon { }
IconFileUpload.defaultProps = {
    iconName: 'rec-icon-file-upload',
    iconClass: 'rec-icon-file-upload'
};

export class IconFilterList extends BaseIcon { }
IconFilterList.defaultProps = {
    iconName: 'rec-icon-filter-list',
    iconClass: 'rec-icon-filter-list'
};

export class IconFullscreenExit extends BaseIcon { }
IconFullscreenExit.defaultProps = {
    iconName: 'rec-icon-fullscreen-exit',
    iconClass: 'rec-icon-fullscreen-exit'
};

export class IconFullscreen extends BaseIcon { }
IconFullscreen.defaultProps = {
    iconName: 'rec-icon-fullscreen',
    iconClass: 'rec-icon-fullscreen'
};

export class IconImportExport extends BaseIcon { }
IconImportExport.defaultProps = {
    iconName: 'rec-icon-import-export',
    iconClass: 'rec-icon-import-export'
};

export class IconKeyboardReturn extends BaseIcon { }
IconKeyboardReturn.defaultProps = {
    iconName: 'rec-icon-keyboard-return',
    iconClass: 'rec-icon-keyboard-return'
};

export class IconKeyboardTab extends BaseIcon { }
IconKeyboardTab.defaultProps = {
    iconName: 'rec-icon-keyboard-tab',
    iconClass: 'rec-icon-keyboard-tab'
};

export class IconMenu extends BaseIcon { }
IconMenu.defaultProps = {
    iconName: 'rec-icon-menu',
    iconClass: 'rec-icon-menu'
};

export class IconReply extends BaseIcon { }
IconReply.defaultProps = {
    iconName: 'rec-icon-reply',
    iconClass: 'rec-icon-reply'
};

export class IconSwapHoriz extends BaseIcon { }
IconSwapHoriz.defaultProps = {
    iconName: 'rec-icon-swap-horiz',
    iconClass: 'rec-icon-swap-horiz'
};

export class IconApps extends BaseIcon { }
IconApps.defaultProps = {
    iconName: 'rec-icon-apps',
    iconClass: 'rec-icon-apps'
};

export class IconCached extends BaseIcon { }
IconCached.defaultProps = {
    iconName: 'rec-icon-cached',
    iconClass: 'rec-icon-cached'
};

export class IconDelete extends BaseIcon { }
IconDelete.defaultProps = {
    iconName: 'rec-icon-delete',
    iconClass: 'rec-icon-delete'
};

export class IconExitToApp extends BaseIcon { }
IconExitToApp.defaultProps = {
    iconName: 'rec-icon-exit-to-app',
    iconClass: 'rec-icon-exit-to-app'
};

export class IconHistory extends BaseIcon { }
IconHistory.defaultProps = {
    iconName: 'rec-icon-history',
    iconClass: 'rec-icon-history'
};

export class IconInput extends BaseIcon { }
IconInput.defaultProps = {
    iconName: 'rec-icon-input',
    iconClass: 'rec-icon-input'
};

export class IconLaunch extends BaseIcon { }
IconLaunch.defaultProps = {
    iconName: 'rec-icon-launch',
    iconClass: 'rec-icon-launch'
};

export class IconLockOpen extends BaseIcon { }
IconLockOpen.defaultProps = {
    iconName: 'rec-icon-lock-open',
    iconClass: 'rec-icon-lock-open'
};

export class IconLockOutline extends BaseIcon { }
IconLockOutline.defaultProps = {
    iconName: 'rec-icon-lock-outline',
    iconClass: 'rec-icon-lock-outline'
};

export class IconLock extends BaseIcon { }
IconLock.defaultProps = {
    iconName: 'rec-icon-lock',
    iconClass: 'rec-icon-lock'
};

export class IconLoop extends BaseIcon { }
IconLoop.defaultProps = {
    iconName: 'rec-icon-loop',
    iconClass: 'rec-icon-loop'
};

export class IconOpenInBrowser extends BaseIcon { }
IconOpenInBrowser.defaultProps = {
    iconName: 'rec-icon-open-in-browser',
    iconClass: 'rec-icon-open-in-browser'
};

export class IconOpenWith extends BaseIcon { }
IconOpenWith.defaultProps = {
    iconName: 'rec-icon-open-with',
    iconClass: 'rec-icon-open-with'
};

export class IconPageview extends BaseIcon { }
IconPageview.defaultProps = {
    iconName: 'rec-icon-pageview',
    iconClass: 'rec-icon-pageview'
};

export class IconRemoveCircleOutline extends BaseIcon { }
IconRemoveCircleOutline.defaultProps = {
    iconName: 'rec-icon-remove-circle-outline',
    iconClass: 'rec-icon-remove-circle-outline'
};

export class IconRemoveCircle extends BaseIcon { }
IconRemoveCircle.defaultProps = {
    iconName: 'rec-icon-remove-circle',
    iconClass: 'rec-icon-remove-circle'
};

export class IconRemove extends BaseIcon { }
IconRemove.defaultProps = {
    iconName: 'rec-icon-remove',
    iconClass: 'rec-icon-remove'
};

export class IconReplay extends BaseIcon { }
IconReplay.defaultProps = {
    iconName: 'rec-icon-replay',
    iconClass: 'rec-icon-replay'
};

export class IconShare extends BaseIcon { }
IconShare.defaultProps = {
    iconName: 'rec-icon-share',
    iconClass: 'rec-icon-share'
};

export class IconBookmarkBorder extends BaseIcon { }
IconBookmarkBorder.defaultProps = {
    iconName: 'rec-icon-bookmark-border',
    iconClass: 'rec-icon-bookmark-border'
};

export class IconBookmark extends BaseIcon { }
IconBookmark.defaultProps = {
    iconName: 'rec-icon-bookmark',
    iconClass: 'rec-icon-bookmark'
};

export class IconFavoriteBorder extends BaseIcon { }
IconFavoriteBorder.defaultProps = {
    iconName: 'rec-icon-favorite-border',
    iconClass: 'rec-icon-favorite-border'
};

export class IconFavorite extends BaseIcon { }
IconFavorite.defaultProps = {
    iconName: 'rec-icon-favorite',
    iconClass: 'rec-icon-favorite'
};

export class IconHelp extends BaseIcon { }
IconHelp.defaultProps = {
    iconName: 'rec-icon-help',
    iconClass: 'rec-icon-help'
};

export class IconHelpOutline extends BaseIcon { }
IconHelpOutline.defaultProps = {
    iconName: 'rec-icon-help-outline',
    iconClass: 'rec-icon-help-outline'
};

export class IconInfoOutline extends BaseIcon { }
IconInfoOutline.defaultProps = {
    iconName: 'rec-icon-info-outline',
    iconClass: 'rec-icon-info-outline'
};

export class IconLabelOutline extends BaseIcon { }
IconLabelOutline.defaultProps = {
    iconName: 'rec-icon-label-outline',
    iconClass: 'rec-icon-label-outline'
};

export class IconLabel extends BaseIcon { }
IconLabel.defaultProps = {
    iconName: 'rec-icon-label',
    iconClass: 'rec-icon-label'
};

export class IconGlobe extends BaseIcon { }
IconGlobe.defaultProps = {
    iconName: 'rec-icon-globe',
    iconClass: 'rec-icon-globe'
};

export class IconReport extends BaseIcon { }
IconReport.defaultProps = {
    iconName: 'rec-icon-report',
    iconClass: 'rec-icon-report'
};

export class IconStarBorder extends BaseIcon { }
IconStarBorder.defaultProps = {
    iconName: 'rec-icon-star-border',
    iconClass: 'rec-icon-star-border'
};

export class IconStarHalf extends BaseIcon { }
IconStarHalf.defaultProps = {
    iconName: 'rec-icon-star-half',
    iconClass: 'rec-icon-star-half'
};

export class IconStarInHalves extends BaseIcon { }
IconStarInHalves.defaultProps = {
    iconName: 'rec-icon-star-in-halves',
    iconClass: 'rec-icon-star-in-halves'
};

export class IconStar extends BaseIcon { }
IconStar.defaultProps = {
    iconName: 'rec-icon-star',
    iconClass: 'rec-icon-star'
};

export class IconThumbDown extends BaseIcon { }
IconThumbDown.defaultProps = {
    iconName: 'rec-icon-thumb-down',
    iconClass: 'rec-icon-thumb-down'
};

export class IconThumbUp extends BaseIcon { }
IconThumbUp.defaultProps = {
    iconName: 'rec-icon-thumb-up',
    iconClass: 'rec-icon-thumb-up'
};

export class IconThumbsUpDown extends BaseIcon { }
IconThumbsUpDown.defaultProps = {
    iconName: 'rec-icon-thumbs-up-down',
    iconClass: 'rec-icon-thumbs-up-down'
};

export class IconDashboard extends BaseIcon { }
IconDashboard.defaultProps = {
    iconName: 'rec-icon-dashboard',
    iconClass: 'rec-icon-dashboard'
};

export class IconFlag extends BaseIcon { }
IconFlag.defaultProps = {
    iconName: 'rec-icon-flag',
    iconClass: 'rec-icon-flag'
};

export class IconList extends BaseIcon { }
IconList.defaultProps = {
    iconName: 'rec-icon-list',
    iconClass: 'rec-icon-list'
};

export class IconMap extends BaseIcon { }
IconMap.defaultProps = {
    iconName: 'rec-icon-map',
    iconClass: 'rec-icon-map'
};

export class IconMyLocation extends BaseIcon { }
IconMyLocation.defaultProps = {
    iconName: 'rec-icon-my-location',
    iconClass: 'rec-icon-my-location'
};

export class IconNavigation extends BaseIcon { }
IconNavigation.defaultProps = {
    iconName: 'rec-icon-navigation',
    iconClass: 'rec-icon-navigation'
};

export class IconPinDrop extends BaseIcon { }
IconPinDrop.defaultProps = {
    iconName: 'rec-icon-pin-drop',
    iconClass: 'rec-icon-pin-drop'
};

export class IconPin extends BaseIcon { }
IconPin.defaultProps = {
    iconName: 'rec-icon-pin',
    iconClass: 'rec-icon-pin'
};

export class IconVerifiedUser extends BaseIcon { }
IconVerifiedUser.defaultProps = {
    iconName: 'rec-icon-verified-user',
    iconClass: 'rec-icon-verified-user'
};

export class IconViewAgenda extends BaseIcon { }
IconViewAgenda.defaultProps = {
    iconName: 'rec-icon-view-agenda',
    iconClass: 'rec-icon-view-agenda'
};

export class IconViewArray extends BaseIcon { }
IconViewArray.defaultProps = {
    iconName: 'rec-icon-view-array',
    iconClass: 'rec-icon-view-array'
};

export class IconViewColumn extends BaseIcon { }
IconViewColumn.defaultProps = {
    iconName: 'rec-icon-view-column',
    iconClass: 'rec-icon-view-column'
};

export class IconViewHeadline extends BaseIcon { }
IconViewHeadline.defaultProps = {
    iconName: 'rec-icon-view-headline',
    iconClass: 'rec-icon-view-headline'
};

export class IconViewList extends BaseIcon { }
IconViewList.defaultProps = {
    iconName: 'rec-icon-view-list',
    iconClass: 'rec-icon-view-list'
};

export class IconViewModule extends BaseIcon { }
IconViewModule.defaultProps = {
    iconName: 'rec-icon-view-module',
    iconClass: 'rec-icon-view-module'
};

export class IconViewQuilt extends BaseIcon { }
IconViewQuilt.defaultProps = {
    iconName: 'rec-icon-view-quilt',
    iconClass: 'rec-icon-view-quilt'
};

export class IconViewStream extends BaseIcon { }
IconViewStream.defaultProps = {
    iconName: 'rec-icon-view-stream',
    iconClass: 'rec-icon-view-stream'
};

export class IconViewWeek extends BaseIcon { }
IconViewWeek.defaultProps = {
    iconName: 'rec-icon-view-week',
    iconClass: 'rec-icon-view-week'
};

export class IconFastForward extends BaseIcon { }
IconFastForward.defaultProps = {
    iconName: 'rec-icon-fast-forward',
    iconClass: 'rec-icon-fast-forward'
};

export class IconMicNone extends BaseIcon { }
IconMicNone.defaultProps = {
    iconName: 'rec-icon-mic-none',
    iconClass: 'rec-icon-mic-none'
};

export class IconMicOff extends BaseIcon { }
IconMicOff.defaultProps = {
    iconName: 'rec-icon-mic-off',
    iconClass: 'rec-icon-mic-off'
};

export class IconMic extends BaseIcon { }
IconMic.defaultProps = {
    iconName: 'rec-icon-mic',
    iconClass: 'rec-icon-mic'
};

export class IconPauseCircleOutline extends BaseIcon { }
IconPauseCircleOutline.defaultProps = {
    iconName: 'rec-icon-pause-circle-outline',
    iconClass: 'rec-icon-pause-circle-outline'
};

export class IconPauseCircle extends BaseIcon { }
IconPauseCircle.defaultProps = {
    iconName: 'rec-icon-pause-circle',
    iconClass: 'rec-icon-pause-circle'
};

export class IconPause extends BaseIcon { }
IconPause.defaultProps = {
    iconName: 'rec-icon-pause',
    iconClass: 'rec-icon-pause'
};

export class IconPlayArrow extends BaseIcon { }
IconPlayArrow.defaultProps = {
    iconName: 'rec-icon-play-arrow',
    iconClass: 'rec-icon-play-arrow'
};

export class IconPlayCircleOutline extends BaseIcon { }
IconPlayCircleOutline.defaultProps = {
    iconName: 'rec-icon-play-circle-outline',
    iconClass: 'rec-icon-play-circle-outline'
};

export class IconPlayCircle extends BaseIcon { }
IconPlayCircle.defaultProps = {
    iconName: 'rec-icon-play-circle',
    iconClass: 'rec-icon-play-circle'
};

export class IconSkipNext extends BaseIcon { }
IconSkipNext.defaultProps = {
    iconName: 'rec-icon-skip-next',
    iconClass: 'rec-icon-skip-next'
};

export class IconVisibilityOff extends BaseIcon { }
IconVisibilityOff.defaultProps = {
    iconName: 'rec-icon-visibility-off',
    iconClass: 'rec-icon-visibility-off'
};

export class IconVisibility extends BaseIcon { }
IconVisibility.defaultProps = {
    iconName: 'rec-icon-visibility',
    iconClass: 'rec-icon-visibility'
};

export class IconVolumeDown extends BaseIcon { }
IconVolumeDown.defaultProps = {
    iconName: 'rec-icon-volume-down',
    iconClass: 'rec-icon-volume-down'
};

export class IconVolumeMute extends BaseIcon { }
IconVolumeMute.defaultProps = {
    iconName: 'rec-icon-volume-mute',
    iconClass: 'rec-icon-volume-mute'
};

export class IconVolumeOff extends BaseIcon { }
IconVolumeOff.defaultProps = {
    iconName: 'rec-icon-volume-off',
    iconClass: 'rec-icon-volume-off'
};

export class IconVolumeUp extends BaseIcon { }
IconVolumeUp.defaultProps = {
    iconName: 'rec-icon-volume-up',
    iconClass: 'rec-icon-volume-up'
};

export class IconWork extends BaseIcon { }
IconWork.defaultProps = {
    iconName: 'rec-icon-work',
    iconClass: 'rec-icon-work'
};

export class IconCardTravel extends BaseIcon { }
IconCardTravel.defaultProps = {
    iconName: 'rec-icon-card-travel',
    iconClass: 'rec-icon-card-travel'
};

export class IconCartAdd extends BaseIcon { }
IconCartAdd.defaultProps = {
    iconName: 'rec-icon-cart-add',
    iconClass: 'rec-icon-cart-add'
};

export class IconDesktopMac extends BaseIcon { }
IconDesktopMac.defaultProps = {
    iconName: 'rec-icon-desktop-mac',
    iconClass: 'rec-icon-desktop-mac'
};

export class IconDesktopWindows extends BaseIcon { }
IconDesktopWindows.defaultProps = {
    iconName: 'rec-icon-desktop-windows',
    iconClass: 'rec-icon-desktop-windows'
};

export class IconHearing extends BaseIcon { }
IconHearing.defaultProps = {
    iconName: 'rec-icon-hearing',
    iconClass: 'rec-icon-hearing'
};

export class IconKeyboard extends BaseIcon { }
IconKeyboard.defaultProps = {
    iconName: 'rec-icon-keyboard',
    iconClass: 'rec-icon-keyboard'
};

export class IconLaptop extends BaseIcon { }
IconLaptop.defaultProps = {
    iconName: 'rec-icon-laptop',
    iconClass: 'rec-icon-laptop'
};

export class IconPayment extends BaseIcon { }
IconPayment.defaultProps = {
    iconName: 'rec-icon-payment',
    iconClass: 'rec-icon-payment'
};

export class IconPhoneAndroid extends BaseIcon { }
IconPhoneAndroid.defaultProps = {
    iconName: 'rec-icon-phone-android',
    iconClass: 'rec-icon-phone-android'
};

export class IconPhoneIphone extends BaseIcon { }
IconPhoneIphone.defaultProps = {
    iconName: 'rec-icon-phone-iphone',
    iconClass: 'rec-icon-phone-iphone'
};

export class IconSmartphoneLandscape extends BaseIcon { }
IconSmartphoneLandscape.defaultProps = {
    iconName: 'rec-icon-smartphone-landscape',
    iconClass: 'rec-icon-smartphone-landscape'
};

export class IconSmartphone extends BaseIcon { }
IconSmartphone.defaultProps = {
    iconName: 'rec-icon-smartphone',
    iconClass: 'rec-icon-smartphone'
};

export class IconStore extends BaseIcon { }
IconStore.defaultProps = {
    iconName: 'rec-icon-store',
    iconClass: 'rec-icon-store'
};

export class IconTabletAndroid extends BaseIcon { }
IconTabletAndroid.defaultProps = {
    iconName: 'rec-icon-tablet-android',
    iconClass: 'rec-icon-tablet-android'
};

export class IconTabletLandscape extends BaseIcon { }
IconTabletLandscape.defaultProps = {
    iconName: 'rec-icon-tablet-landscape',
    iconClass: 'rec-icon-tablet-landscape'
};

export class IconTabletMac extends BaseIcon { }
IconTabletMac.defaultProps = {
    iconName: 'rec-icon-tablet-mac',
    iconClass: 'rec-icon-tablet-mac'
};

export class IconTv extends BaseIcon { }
IconTv.defaultProps = {
    iconName: 'rec-icon-tv',
    iconClass: 'rec-icon-tv'
};

export class IconVideocamOff extends BaseIcon { }
IconVideocamOff.defaultProps = {
    iconName: 'rec-icon-videocam-off',
    iconClass: 'rec-icon-videocam-off'
};

export class IconVideocam extends BaseIcon { }
IconVideocam.defaultProps = {
    iconName: 'rec-icon-videocam',
    iconClass: 'rec-icon-videocam'
};

export class IconAnnouncement extends BaseIcon { }
IconAnnouncement.defaultProps = {
    iconName: 'rec-icon-announcement',
    iconClass: 'rec-icon-announcement'
};

export class IconAttachment extends BaseIcon { }
IconAttachment.defaultProps = {
    iconName: 'rec-icon-attachment',
    iconClass: 'rec-icon-attachment'
};

export class IconCamera extends BaseIcon { }
IconCamera.defaultProps = {
    iconName: 'rec-icon-camera',
    iconClass: 'rec-icon-camera'
};

export class IconChatBubble extends BaseIcon { }
IconChatBubble.defaultProps = {
    iconName: 'rec-icon-chat-bubble',
    iconClass: 'rec-icon-chat-bubble'
};

export class IconChat extends BaseIcon { }
IconChat.defaultProps = {
    iconName: 'rec-icon-chat',
    iconClass: 'rec-icon-chat'
};

export class IconClipboard extends BaseIcon { }
IconClipboard.defaultProps = {
    iconName: 'rec-icon-clipboard',
    iconClass: 'rec-icon-clipboard'
};

export class IconComment extends BaseIcon { }
IconComment.defaultProps = {
    iconName: 'rec-icon-comment',
    iconClass: 'rec-icon-comment'
};

export class IconCut extends BaseIcon { }
IconCut.defaultProps = {
    iconName: 'rec-icon-cut',
    iconClass: 'rec-icon-cut'
};

export class IconEdit extends BaseIcon { }
IconEdit.defaultProps = {
    iconName: 'rec-icon-edit',
    iconClass: 'rec-icon-edit'
};

export class IconExplore extends BaseIcon { }
IconExplore.defaultProps = {
    iconName: 'rec-icon-explore',
    iconClass: 'rec-icon-explore'
};

export class IconForum extends BaseIcon { }
IconForum.defaultProps = {
    iconName: 'rec-icon-forum',
    iconClass: 'rec-icon-forum'
};

export class IconLink extends BaseIcon { }
IconLink.defaultProps = {
    iconName: 'rec-icon-link',
    iconClass: 'rec-icon-link'
};

export class IconLinkOff extends BaseIcon { }
IconLinkOff.defaultProps = {
    iconName: 'rec-icon-link-off',
    iconClass: 'rec-icon-link-off'
};

export class IconMouse extends BaseIcon { }
IconMouse.defaultProps = {
    iconName: 'rec-icon-mouse',
    iconClass: 'rec-icon-mouse'
};

export class IconPhone extends BaseIcon { }
IconPhone.defaultProps = {
    iconName: 'rec-icon-phone',
    iconClass: 'rec-icon-phone'
};

export class IconPhoto extends BaseIcon { }
IconPhoto.defaultProps = {
    iconName: 'rec-icon-photo',
    iconClass: 'rec-icon-photo'
};

export class IconPhotoUnavailable extends BaseIcon { }
IconPhotoUnavailable.defaultProps = {
    iconName: 'rec-icon-photo-unavailable',
    iconClass: 'rec-icon-photo-unavailable'
};

export class IconPhotoGallery extends BaseIcon { }
IconPhotoGallery.defaultProps = {
    iconName: 'rec-icon-photo-gallery',
    iconClass: 'rec-icon-photo-gallery'
};

export class IconPrint extends BaseIcon { }
IconPrint.defaultProps = {
    iconName: 'rec-icon-print',
    iconClass: 'rec-icon-print'
};

export class IconSave extends BaseIcon { }
IconSave.defaultProps = {
    iconName: 'rec-icon-save',
    iconClass: 'rec-icon-save'
};

export class IconTextsms extends BaseIcon { }
IconTextsms.defaultProps = {
    iconName: 'rec-icon-textsms',
    iconClass: 'rec-icon-textsms'
};

export class IconAtm extends BaseIcon { }
IconAtm.defaultProps = {
    iconName: 'rec-icon-atm',
    iconClass: 'rec-icon-atm'
};

export class IconAttraction extends BaseIcon { }
IconAttraction.defaultProps = {
    iconName: 'rec-icon-attraction',
    iconClass: 'rec-icon-attraction'
};

export class IconBar extends BaseIcon { }
IconBar.defaultProps = {
    iconName: 'rec-icon-bar',
    iconClass: 'rec-icon-bar'
};

export class IconBike extends BaseIcon { }
IconBike.defaultProps = {
    iconName: 'rec-icon-bike',
    iconClass: 'rec-icon-bike'
};

export class IconBoat extends BaseIcon { }
IconBoat.defaultProps = {
    iconName: 'rec-icon-boat',
    iconClass: 'rec-icon-boat'
};

export class IconCafe extends BaseIcon { }
IconCafe.defaultProps = {
    iconName: 'rec-icon-cafe',
    iconClass: 'rec-icon-cafe'
};

export class IconCloudUpload extends BaseIcon { }
IconCloudUpload.defaultProps = {
    iconName: 'rec-icon-cloud-upload',
    iconClass: 'rec-icon-cloud-upload'
};

export class IconConvenienceStore extends BaseIcon { }
IconConvenienceStore.defaultProps = {
    iconName: 'rec-icon-convenience-store',
    iconClass: 'rec-icon-convenience-store'
};

export class IconDescription extends BaseIcon { }
IconDescription.defaultProps = {
    iconName: 'rec-icon-description',
    iconClass: 'rec-icon-description'
};

export class IconDining extends BaseIcon { }
IconDining.defaultProps = {
    iconName: 'rec-icon-dining',
    iconClass: 'rec-icon-dining'
};

export class IconDirections extends BaseIcon { }
IconDirections.defaultProps = {
    iconName: 'rec-icon-directions',
    iconClass: 'rec-icon-directions'
};

export class IconEmail extends BaseIcon { }
IconEmail.defaultProps = {
    iconName: 'rec-icon-email',
    iconClass: 'rec-icon-email'
};

export class IconEmailOutline extends BaseIcon { }
IconEmailOutline.defaultProps = {
    iconName: 'rec-icon-email-outline',
    iconClass: 'rec-icon-email-outline'
};

export class IconFlight extends BaseIcon { }
IconFlight.defaultProps = {
    iconName: 'rec-icon-flight',
    iconClass: 'rec-icon-flight'
};

export class IconFolderOpen extends BaseIcon { }
IconFolderOpen.defaultProps = {
    iconName: 'rec-icon-folder-open',
    iconClass: 'rec-icon-folder-open'
};

export class IconFolder extends BaseIcon { }
IconFolder.defaultProps = {
    iconName: 'rec-icon-folder',
    iconClass: 'rec-icon-folder'
};

export class IconGasStation extends BaseIcon { }
IconGasStation.defaultProps = {
    iconName: 'rec-icon-gas-station',
    iconClass: 'rec-icon-gas-station'
};

export class IconHospital extends BaseIcon { }
IconHospital.defaultProps = {
    iconName: 'rec-icon-hospital',
    iconClass: 'rec-icon-hospital'
};

export class IconHotel extends BaseIcon { }
IconHotel.defaultProps = {
    iconName: 'rec-icon-hotel',
    iconClass: 'rec-icon-hotel'
};

export class IconMailOpen extends BaseIcon { }
IconMailOpen.defaultProps = {
    iconName: 'rec-icon-mail-open',
    iconClass: 'rec-icon-mail-open'
};

export class IconMoveToInbox extends BaseIcon { }
IconMoveToInbox.defaultProps = {
    iconName: 'rec-icon-move-to-inbox',
    iconClass: 'rec-icon-move-to-inbox'
};

export class IconNoteAdd extends BaseIcon { }
IconNoteAdd.defaultProps = {
    iconName: 'rec-icon-note-add',
    iconClass: 'rec-icon-note-add'
};

export class IconParking extends BaseIcon { }
IconParking.defaultProps = {
    iconName: 'rec-icon-parking',
    iconClass: 'rec-icon-parking'
};

export class IconShipping extends BaseIcon { }
IconShipping.defaultProps = {
    iconName: 'rec-icon-shipping',
    iconClass: 'rec-icon-shipping'
};

export class IconTaxi extends BaseIcon { }
IconTaxi.defaultProps = {
    iconName: 'rec-icon-taxi',
    iconClass: 'rec-icon-taxi'
};

export class IconTrain extends BaseIcon { }
IconTrain.defaultProps = {
    iconName: 'rec-icon-train',
    iconClass: 'rec-icon-train'
};

export class IconTransit extends BaseIcon { }
IconTransit.defaultProps = {
    iconName: 'rec-icon-transit',
    iconClass: 'rec-icon-transit'
};

export class IconWalk extends BaseIcon { }
IconWalk.defaultProps = {
    iconName: 'rec-icon-walk',
    iconClass: 'rec-icon-walk'
};

export class IconBus extends BaseIcon { }
IconBus.defaultProps = {
    iconName: 'rec-icon-bus',
    iconClass: 'rec-icon-bus'
};

export class IconCloseCircleOutline extends BaseIcon { }
IconCloseCircleOutline.defaultProps = {
    iconName: 'rec-icon-close-circle-outline',
    iconClass: 'rec-icon-close-circle-outline'
};

export class IconCloud extends BaseIcon { }
IconCloud.defaultProps = {
    iconName: 'rec-icon-cloud',
    iconClass: 'rec-icon-cloud'
};

export class IconCar extends BaseIcon { }
IconCar.defaultProps = {
    iconName: 'rec-icon-car',
    iconClass: 'rec-icon-car'
};

export class IconFastRewind extends BaseIcon { }
IconFastRewind.defaultProps = {
    iconName: 'rec-icon-fast-rewind',
    iconClass: 'rec-icon-fast-rewind'
};

export class IconHeadsetMic extends BaseIcon { }
IconHeadsetMic.defaultProps = {
    iconName: 'rec-icon-headset-mic',
    iconClass: 'rec-icon-headset-mic'
};

export class IconHeadset extends BaseIcon { }
IconHeadset.defaultProps = {
    iconName: 'rec-icon-headset',
    iconClass: 'rec-icon-headset'
};

export class IconMall extends BaseIcon { }
IconMall.defaultProps = {
    iconName: 'rec-icon-mall',
    iconClass: 'rec-icon-mall'
};

export class IconOffer extends BaseIcon { }
IconOffer.defaultProps = {
    iconName: 'rec-icon-offer',
    iconClass: 'rec-icon-offer'
};

export class IconSend extends BaseIcon { }
IconSend.defaultProps = {
    iconName: 'rec-icon-send',
    iconClass: 'rec-icon-send'
};

export class IconSkipPrevious extends BaseIcon { }
IconSkipPrevious.defaultProps = {
    iconName: 'rec-icon-skip-previous',
    iconClass: 'rec-icon-skip-previous'
};

export class IconTerrain extends BaseIcon { }
IconTerrain.defaultProps = {
    iconName: 'rec-icon-terrain',
    iconClass: 'rec-icon-terrain'
};

export class IconArrowLeft extends BaseIcon { }
IconArrowLeft.defaultProps = {
    iconName: 'rec-icon-arrow-left',
    iconClass: 'rec-icon-arrow-left'
};

export class IconArrowRight extends BaseIcon { }
IconArrowRight.defaultProps = {
    iconName: 'rec-icon-arrow-right',
    iconClass: 'rec-icon-arrow-right'
};

export class IconBlock extends BaseIcon { }
IconBlock.defaultProps = {
    iconName: 'rec-icon-block',
    iconClass: 'rec-icon-block'
};

export class IconUnfoldLess extends BaseIcon { }
IconUnfoldLess.defaultProps = {
    iconName: 'rec-icon-unfold-less',
    iconClass: 'rec-icon-unfold-less'
};

export class IconUnfoldMore extends BaseIcon { }
IconUnfoldMore.defaultProps = {
    iconName: 'rec-icon-unfold-more',
    iconClass: 'rec-icon-unfold-more'
};

export class IconCheckCircleOutline extends BaseIcon { }
IconCheckCircleOutline.defaultProps = {
    iconName: 'rec-icon-check-circle-outline',
    iconClass: 'rec-icon-check-circle-outline'
};

export class IconHourglassHalf extends BaseIcon { }
IconHourglassHalf.defaultProps = {
    iconName: 'rec-icon-hourglass-half',
    iconClass: 'rec-icon-hourglass-half'
};

export class IconActivityWater extends BaseIcon { }
IconActivityWater.defaultProps = {
    iconName: 'rec-icon-activity-water',
    iconClass: 'rec-icon-activity-water'
};

export class IconBullet extends BaseIcon { }
IconBullet.defaultProps = {
    iconName: 'rec-icon-bullet',
    iconClass: 'rec-icon-bullet'
};

export class IconCard extends BaseIcon { }
IconCard.defaultProps = {
    iconName: 'rec-icon-card',
    iconClass: 'rec-icon-card'
};

export class IconTent extends BaseIcon { }
IconTent.defaultProps = {
    iconName: 'rec-icon-tent',
    iconClass: 'rec-icon-tent'
};

export class IconTicket extends BaseIcon { }
IconTicket.defaultProps = {
    iconName: 'rec-icon-ticket',
    iconClass: 'rec-icon-ticket'
};

export class IconSort extends BaseIcon { }
IconSort.defaultProps = {
    iconName: 'rec-icon-sort',
    iconClass: 'rec-icon-sort'
};

export class IconAccessible extends BaseIcon { }
IconAccessible.defaultProps = {
    iconName: 'rec-icon-accessible',
    iconClass: 'rec-icon-accessible'
};

export class IconPicnicTable extends BaseIcon { }
IconPicnicTable.defaultProps = {
    iconName: 'rec-icon-picnic-table',
    iconClass: 'rec-icon-picnic-table'
};

export class IconCardOutline extends BaseIcon { }
IconCardOutline.defaultProps = {
    iconName: 'rec-icon-card-outline',
    iconClass: 'rec-icon-card-outline'
};

export class IconPet extends BaseIcon { }
IconPet.defaultProps = {
    iconName: 'rec-icon-pet',
    iconClass: 'rec-icon-pet'
};

export class IconElectricity05 extends BaseIcon { }
IconElectricity05.defaultProps = {
    iconName: 'rec-icon-electricity-05',
    iconClass: 'rec-icon-electricity-05'
};

export class IconElectricity15 extends BaseIcon { }
IconElectricity15.defaultProps = {
    iconName: 'rec-icon-electricity-15',
    iconClass: 'rec-icon-electricity-15'
};

export class IconElectricity20 extends BaseIcon { }
IconElectricity20.defaultProps = {
    iconName: 'rec-icon-electricity-20',
    iconClass: 'rec-icon-electricity-20'
};

export class IconElectricity30 extends BaseIcon { }
IconElectricity30.defaultProps = {
    iconName: 'rec-icon-electricity-30',
    iconClass: 'rec-icon-electricity-30'
};

export class IconElectricity50 extends BaseIcon { }
IconElectricity50.defaultProps = {
    iconName: 'rec-icon-electricity-50',
    iconClass: 'rec-icon-electricity-50'
};

export class IconElectricity100 extends BaseIcon { }
IconElectricity100.defaultProps = {
    iconName: 'rec-icon-electricity-100',
    iconClass: 'rec-icon-electricity-100'
};

export class IconTrailerHookup extends BaseIcon { }
IconTrailerHookup.defaultProps = {
    iconName: 'rec-icon-trailer-hookup',
    iconClass: 'rec-icon-trailer-hookup'
};

export class IconLottery extends BaseIcon { }
IconLottery.defaultProps = {
    iconName: 'rec-icon-lottery',
    iconClass: 'rec-icon-lottery'
};

export class IconTree extends BaseIcon { }
IconTree.defaultProps = {
    iconName: 'rec-icon-tree',
    iconClass: 'rec-icon-tree'
};

export class IconCompass extends BaseIcon { }
IconCompass.defaultProps = {
    iconName: 'rec-icon-compass',
    iconClass: 'rec-icon-compass'
};

export class IconChevronDownCircleOutline extends BaseIcon { }
IconChevronDownCircleOutline.defaultProps = {
    iconName: 'rec-icon-chevron-down-circle-outline',
    iconClass: 'rec-icon-chevron-down-circle-outline'
};

export class IconFacebook extends BaseIcon { }
IconFacebook.defaultProps = {
    iconName: 'rec-icon-facebook',
    iconClass: 'rec-icon-facebook'
};

export class IconInstagram extends BaseIcon { }
IconInstagram.defaultProps = {
    iconName: 'rec-icon-instagram',
    iconClass: 'rec-icon-instagram'
};

export class IconPinterest extends BaseIcon { }
IconPinterest.defaultProps = {
    iconName: 'rec-icon-pinterest',
    iconClass: 'rec-icon-pinterest'
};

export class IconBoatSite extends BaseIcon { }
IconBoatSite.defaultProps = {
    iconName: 'rec-icon-boat-site',
    iconClass: 'rec-icon-boat-site'
};

export class IconCabin extends BaseIcon { }
IconCabin.defaultProps = {
    iconName: 'rec-icon-cabin',
    iconClass: 'rec-icon-cabin'
};

export class IconSmallTent extends BaseIcon { }
IconSmallTent.defaultProps = {
    iconName: 'rec-icon-small-tent',
    iconClass: 'rec-icon-small-tent'
};

export class IconHorseSite extends BaseIcon { }
IconHorseSite.defaultProps = {
    iconName: 'rec-icon-horse-site',
    iconClass: 'rec-icon-horse-site'
};

export class IconRvTrailer extends BaseIcon { }
IconRvTrailer.defaultProps = {
    iconName: 'rec-icon-rv-trailer',
    iconClass: 'rec-icon-rv-trailer'
};

export class IconYurt extends BaseIcon { }
IconYurt.defaultProps = {
    iconName: 'rec-icon-yurt',
    iconClass: 'rec-icon-yurt'
};

export class IconRental extends BaseIcon { }
IconRental.defaultProps = {
    iconName: 'rec-icon-rental',
    iconClass: 'rec-icon-rental'
};

export class IconPermit extends BaseIcon { }
IconPermit.defaultProps = {
    iconName: 'rec-icon-permit',
    iconClass: 'rec-icon-permit'
};

export class IconRecMenu extends BaseIcon { }
IconRecMenu.defaultProps = {
    iconName: 'rec-icon-rec-menu',
    iconClass: 'rec-icon-rec-menu'
};

export class IconRefund extends BaseIcon { }
IconRefund.defaultProps = {
    iconName: 'rec-icon-refund',
    iconClass: 'rec-icon-refund'
};

export class IconQuote extends BaseIcon { }
IconQuote.defaultProps = {
    iconName: 'rec-icon-quote',
    iconClass: 'rec-icon-quote'
};

export class IconVehiclePermit extends BaseIcon { }
IconVehiclePermit.defaultProps = {
    iconName: 'rec-icon-vehicle-permit',
    iconClass: 'rec-icon-vehicle-permit'
};

export class IconWaterHookup extends BaseIcon { }
IconWaterHookup.defaultProps = {
    iconName: 'rec-icon-water-hookup',
    iconClass: 'rec-icon-water-hookup'
};

export class IconCellService extends BaseIcon { }
IconCellService.defaultProps = {
    iconName: 'rec-icon-cell-service',
    iconClass: 'rec-icon-cell-service'
};

export class IconCellCarrier extends BaseIcon { }
IconCellCarrier.defaultProps = {
    iconName: 'rec-icon-cell-carrier',
    iconClass: 'rec-icon-cell-carrier'
};

export class IconSun extends BaseIcon { }
IconSun.defaultProps = {
    iconName: 'rec-icon-sun',
    iconClass: 'rec-icon-sun'
};

export class IconMoon extends BaseIcon { }
IconMoon.defaultProps = {
    iconName: 'rec-icon-moon',
    iconClass: 'rec-icon-moon'
};

export class IconGroupCampsite extends BaseIcon { }
IconGroupCampsite.defaultProps = {
    iconName: 'rec-icon-group-campsite',
    iconClass: 'rec-icon-group-campsite'
};

export class IconQrCode extends BaseIcon { }
IconQrCode.defaultProps = {
    iconName: 'rec-icon-qr-code',
    iconClass: 'rec-icon-qr-code'
};

export class IconContract extends BaseIcon { }
IconContract.defaultProps = {
    iconName: 'rec-icon-contract',
    iconClass: 'rec-icon-contract'
};

export class IconExpand extends BaseIcon { }
IconExpand.defaultProps = {
    iconName: 'rec-icon-expand',
    iconClass: 'rec-icon-expand'
};

export class IconOvernight extends BaseIcon { }
IconOvernight.defaultProps = {
    iconName: 'rec-icon-overnight',
    iconClass: 'rec-icon-overnight'
};

export class IconElectricity extends BaseIcon { }
IconElectricity.defaultProps = {
    iconName: 'rec-icon-electricity',
    iconClass: 'rec-icon-electricity'
};

export class IconFire extends BaseIcon { }
IconFire.defaultProps = {
    iconName: 'rec-icon-fire',
    iconClass: 'rec-icon-fire'
};

export class IconCampsite extends BaseIcon { }
IconCampsite.defaultProps = {
    iconName: 'rec-icon-campsite',
    iconClass: 'rec-icon-campsite'
};

export class IconRv extends BaseIcon { }
IconRv.defaultProps = {
    iconName: 'rec-icon-rv',
    iconClass: 'rec-icon-rv'
};

export class IconTrailer extends BaseIcon { }
IconTrailer.defaultProps = {
    iconName: 'rec-icon-trailer',
    iconClass: 'rec-icon-trailer'
};

export class IconPickup extends BaseIcon { }
IconPickup.defaultProps = {
    iconName: 'rec-icon-pickup',
    iconClass: 'rec-icon-pickup'
};

export class IconPopup extends BaseIcon { }
IconPopup.defaultProps = {
    iconName: 'rec-icon-popup',
    iconClass: 'rec-icon-popup'
};

export class IconFifthWheel extends BaseIcon { }
IconFifthWheel.defaultProps = {
    iconName: 'rec-icon-fifthwheel',
    iconClass: 'rec-icon-fifthwheel'
};

export class IconTrailhead extends BaseIcon { }
IconTrailhead.defaultProps = {
    iconName: 'rec-icon-trailhead',
    iconClass: 'rec-icon-trailhead'
};

export class IconShelter extends BaseIcon { }
IconShelter.defaultProps = {
    iconName: 'rec-icon-shelter',
    iconClass: 'rec-icon-shelter'
};

export class IconCourt extends BaseIcon { }
IconCourt.defaultProps = {
    iconName: 'rec-icon-court',
    iconClass: 'rec-icon-court'
};

export class IconBall extends BaseIcon { }
IconBall.defaultProps = {
    iconName: 'rec-icon-ball',
    iconClass: 'rec-icon-ball'
};

export class IconAirfield extends BaseIcon { }
IconAirfield.defaultProps = {
    iconName: 'rec-icon-airfield',
    iconClass: 'rec-icon-airfield'
};

export class IconBoatLaunch extends BaseIcon { }
IconBoatLaunch.defaultProps = {
    iconName: 'rec-icon-boat-launch',
    iconClass: 'rec-icon-boat-launch'
};

export class IconDrinkingWater extends BaseIcon { }
IconDrinkingWater.defaultProps = {
    iconName: 'rec-icon-drinking-water',
    iconClass: 'rec-icon-drinking-water'
};

export class IconEntrance extends BaseIcon { }
IconEntrance.defaultProps = {
    iconName: 'rec-icon-entrance',
    iconClass: 'rec-icon-entrance'
};

export class IconPlayground extends BaseIcon { }
IconPlayground.defaultProps = {
    iconName: 'rec-icon-playground',
    iconClass: 'rec-icon-playground'
};

export class IconRangerStation extends BaseIcon { }
IconRangerStation.defaultProps = {
    iconName: 'rec-icon-ranger-station',
    iconClass: 'rec-icon-ranger-station'
};

export class IconRecycling extends BaseIcon { }
IconRecycling.defaultProps = {
    iconName: 'rec-icon-recycling',
    iconClass: 'rec-icon-recycling'
};

export class IconRestrooms extends BaseIcon { }
IconRestrooms.defaultProps = {
    iconName: 'rec-icon-restrooms',
    iconClass: 'rec-icon-restrooms'
};

export class IconSanitaryDisposalStation extends BaseIcon { }
IconSanitaryDisposalStation.defaultProps = {
    iconName: 'rec-icon-sanitary-disposal-station',
    iconClass: 'rec-icon-sanitary-disposal-station'
};

export class IconShowers extends BaseIcon { }
IconShowers.defaultProps = {
    iconName: 'rec-icon-showers',
    iconClass: 'rec-icon-showers'
};

export class IconTrashDumpster extends BaseIcon { }
IconTrashDumpster.defaultProps = {
    iconName: 'rec-icon-trash-dumpster',
    iconClass: 'rec-icon-trash-dumpster'
};

export class IconViewingArea extends BaseIcon { }
IconViewingArea.defaultProps = {
    iconName: 'rec-icon-viewing-area',
    iconClass: 'rec-icon-viewing-area'
};

export class IconFormatBold extends BaseIcon { }
IconFormatBold.defaultProps = {
    iconName: 'rec-icon-format-bold',
    iconClass: 'rec-icon-format-bold'
};

export class IconFormatItalic extends BaseIcon { }
IconFormatItalic.defaultProps = {
    iconName: 'rec-icon-format-italic',
    iconClass: 'rec-icon-format-italic'
};

export class IconFormatListBulleted extends BaseIcon { }
IconFormatListBulleted.defaultProps = {
    iconName: 'rec-icon-format-list-bulleted',
    iconClass: 'rec-icon-format-list-bulleted'
};

export class IconRedo extends BaseIcon { }
IconRedo.defaultProps = {
    iconName: 'rec-icon-redo',
    iconClass: 'rec-icon-redo'
};

export class IconUndo extends BaseIcon { }
IconUndo.defaultProps = {
    iconName: 'rec-icon-undo',
    iconClass: 'rec-icon-undo'
};
